const iconConsts = {
    icons: {
        PLANE_RIDES: {
            icon: 'las la-plane',
            classAdj: '',
            size: '4xl'
        },
        BOAT_RIDES: {
            icon: 'las la-ship',
            classAdj: '',
            size: '4xl'
        },
        FERRY: {
            icon: 'las la-ship',
            classAdj: '',
            size: '4xl'
        },

        TRAIN: {
            icon: 'las la-train',
            classAdj: '',
            size: '4xl'
        },
        METRO: {
            icon: 'las la-subway',
            classAdj: '',
            size: '4xl'
        },
        TRAMWAY: {
            icon: 'las la-tram',
            classAdj: '',
            size: '4xl'
        },
        TAXI: {
            icon: 'las la-taxi',
            classAdj: '',
            size: '4xl'
        },
        BUS: {
            icon: 'las la-shuttle-van',
            classAdj: '',
            size: '4xl'
        },
        CAR: {
            icon: 'las la-car-side',
            classAdj: '',
            size: '4xl'
        },
        CAR_RENTAL: {
            icon: 'las la-car-side',
            classAdj: '',
            size: '4xl'
        },
        CAR_HIRE: {
            icon: 'las la-car-side',
            classAdj: '',
            size: '4xl'
        },
        RIDE_SHARING: {
            icon: 'las la-car-alt',
            classAdj: '',
            size: '4xl'
        },
        RIDE_POOLING: {
            icon: 'las la-car-alt',
            classAdj: '',
            size: '4xl'
        },
        SCOOTER: {
            icon: 'las la-motorcycle',
            classAdj: '',
            size: '4xl'
        },
        BIKE: {
            icon: 'las la-bicycle',
            classAdj: '',
            size: '4xl'
        },
        E_BIKE: {
            icon: 'las la-bicycle',
            classAdj: '',
            size: '4xl'
        },
        WALKING: {
            icon: 'las la-walking',
            classAdj: '',
            size: '4xl'
        },
        HORSE: {
            icon: 'las la-horse',
            classAdj: '',
            size: '4xl'
        },
        CAMEL: {
            icon: 'las la-paw',
            classAdj: '',
            size: '4xl'
        },
        DONKEY: {
            icon: 'las la-paw',
            classAdj: '',
            size: '4xl'
        },
        ELEPHANT: {
            icon: 'las la-paw',
            classAdj: '',
            size: '4xl'
        },
        AIR_TRAVEL: {
            icon: 'las la-plane-arrival',
            classAdj: '',
            size: '4xl'
        },
        SEA: {
            icon: 'las la-anchor',
            classAdj: '',
            size: '4xl'
        },
        RAILWAY: {
            icon: 'las la-train',
            classAdj: '',
            size: '4xl'
        },
        VEHICULE: {
            icon: 'las la-car-side',
            classAdj: '',
            size: '4xl'
        },
        INTERNATIONAL_TRAVEL: {
            icon: 'las la-globe',
            classAdj: '',
            size: '4xl'
        },
        LOCAL_TRAVEL: {
            icon: 'las la-store-alt',
            classAdj: '',
            size: '4xl'
        },
        HEART: {
            icon: 'lar la-heart',
            classAdj: '',
            size: '4xl'
        },
        HEART_FILLED: {
            icon: 'las la-heart',
            classAdj: '',
            size: '4xl'
        },
        MAP: {
            icon: 'las la-map',
            classAdj: '',
            size: '4xl'
        },
        MAP_MARKER: {
            icon: 'las la-map-marker',
            classAdj: '',
            size: '4xl'
        },
        MAP_MARKERALT: {
            icon: 'ri-map-pin-line',
            classAdj: '',
            size: '2xl'
        },
        MAP_MARKERADDALT: {
            icon: 'ri-map-pin-add-line',
            classAdj: '',
            size: '2xl'
        },

        MAP_MARKED: {
            icon: 'las la-map-marked',
            classAdj: '',
            size: '4xl'
        },
        LANGUAGE: {
            icon: 'las la-language',
            classAdj: '',
            size: '4xl'
        },
        CALENDAR: {
            icon: 'las la-calendar',
            classAdj: '',
            size: '4xl'
        },
        CLOCK: {
            icon: 'las la-clock',
            classAdj: '',
            size: '4xl'
        },
        CLOCKALT: {
            icon: 'ri-time-line',
            classAdj: '',
            size: '4xl'
        },
        MONEYBILL: {
            icon: 'las la-money-bill',
            classAdj: '',
            size: '4xl'
        },
        COINS: {
            icon: 'las la-coins',
            classAdj: '',
            size: '4xl'
        },
        CLONE: {
            icon: 'ri-file-copy-2-line',
            classAdj: '',
            size: '2xl'
        },
        WALLET: {
            icon: 'las la-wallet',
            classAdj: '',
            size: '4xl'
        },

        TIMERALT: {
            icon: 'ri-timer-2-line',
            classAdj: '',
            size: '2xl'
        },
        HIKINGALT: {
            icon: 'las la-hiking',
            classAdj: '',
            size: '4xl'
        },
        HIKING: {
            icon: 'fas fa-hiking',
            classAdj: '',
            size: '3xl'
        },

        USER: {
            icon: 'las la-user',
            classAdj: '',
            size: '4xl'
        },
        ARROW_RIGHT_LONG: {
            icon: 'las la-long-arrow-alt-right',
            classAdj: '',
            size: '4xl'
        },
        ARROW_RIGHT_SHORT: {
            icon: 'las la-arrow-right',
            classAdj: '',
            size: '4xl'
        },
        ARROW_RIGHT_CHEVRON: {
            icon: 'ri-arrow-right-s-line',
            classAdj: '',
            size: '2xl'
        },
        ARROW_DOWN_CHEVRON: {
            icon: 'ri-arrow-down-s-line',
            classAdj: '',
            size: '2xl'
        },
        ARROW_LEFT_LONG: {
            icon: 'las la-long-arrow-alt-left',
            classAdj: '',
            size: '4xl'
        },
        ARROW_LEFT_SHORT: {
            icon: 'las la-arrow-left',
            classAdj: '',
            size: '4xl'
        },
        ARROW_LEFT_CHEVRON: {
            icon: 'ri-arrow-left-s-line',
            classAdj: '',
            size: '2xl'
        },
        CHECK: {
            icon: 'las la-check',
            classAdj: '',
            size: '4xl'
        },
        CHECKDOUBLE: {
            icon: 'las la-check-double',
            classAdj: '',
            size: '4xl'
        },
        CHECKALT: {
            icon: 'ri-check-line',
            classAdj: '',
            size: '2xl'
        },

        LINK: {
            icon: 'las la-link',
            classAdj: '',
            size: '4xl'
        },

        CLOSE: {
            icon: 'las la-times',
            classAdj: '',
            size: '4xl'
        },
        CLOSEALT: {
            icon: 'ri-close-line',
            classAdj: '',
            size: '2xl'
        },

        PLUS: {
            icon: 'ri-add-line',
            classAdj: '',
            size: '2xl'
        },
        WIFI: {
            icon: 'las la-wifi',
            classAdj: '',
            size: '4xl'
        },
        UPLOAD: {
            icon: 'las la-upload',
            classAdj: '',
            size: '4xl'
        },
        MAIL: {
            icon: 'ri-mail-line',
            classAdj: '',
            size: '2xl'
        },

        TRASH: {
            icon: 'las la-trash-alt',
            classAdj: '',
            size: '4xl'
        },
        TRASHALT: {
            icon: 'ri-delete-bin-line',
            classAdj: '',
            size: '2xl'
        },
        IMAGE: {
            icon: 'las la-image',
            classAdj: '',
            size: '4xl'
        },
        IMAGEALT2: {
            icon: 'ri-image-line',
            classAdj: '',
            size: '2xl'
        },
        GALLERY: {
            icon: 'las la-photo-video',
            classAdj: '',
            size: '4xl'
        },
        HOTEL: {
            icon: 'las la-hotel',
            classAdj: '',
            size: '4xl'
        },
        IMAGEALT: {
            icon: 'ri-landscape-line',
            classAdj: '',
            size: '2xl'
        },
        TAG: {
            icon: 'las la-tag',
            classAdj: '',
            size: '4xl'
        },
        TAGS: {
            icon: 'las la-tags',
            classAdj: '',
            size: '4xl'
        },
        EYE: {
            icon: 'las la-eye',
            classAdj: '',
            size: '2xl'
        },
        EYE_SLASH: {
            icon: 'las la-eye-slash',
            classAdj: '',
            size: '2xl'
        },
        HELP: {
            icon: 'las la-question-circle',
            classAdj: '',
            size: '4xl'
        },
        EDIT: {
            icon: 'las la-edit',
            classAdj: '',
            size: '4xl'
        },
        DOTS3H: {
            icon: 'las la-ellipsis-h',
            classAdj: '',
            size: '4xl'
        },
        DOTS3V: {
            icon: 'las la-ellipsis-v',
            classAdj: '',
            size: '4xl'
        },
        DOTS6V: {
            icon: 'las la-braille',
            classAdj: '',
            size: '4xl'
        },
        ADDTEXT: {
            icon: 'ri-file-list-line',
            classAdj: '',
            size: '2xl'
        },
        CHECKLIST: {
            icon: 'las la-list-alt',
            classAdj: '',
            size: '4xl'
        },
        LIST: {
            icon: 'las la-list',
            classAdj: '',
            size: '4xl'
        },
        ADDTEXTALT: {
            icon: 'ri-menu-add-line',
            classAdj: '',
            size: '2xl'
        },
        ADDIMAGE: {
            icon: 'ri-image-add-line',
            classAdj: '',
            size: '2xl'
        },
        QUESTIONBOX: {
            icon: 'ri-questionnaire-line',
            classAdj: '',
            size: '2xl'
        },
        QUESTIONCHAT: {
            icon: 'ri-question-answer-line',
            classAdj: '',
            size: '2xl'
        },
        QUESTIONMARK: {
            icon: 'ri-question-mark',
            classAdj: '',
            size: '2xl'
        },
        QUESTION: {
            icon: 'ri-question-line',
            classAdj: '',
            size: '2xl'
        },

        SPORTS: {
            icon: 'fas fa-running',
            classAdj: '',
            size: '3xl'
        },
        WILD: {
            icon: 'las la-tree',
            classAdj: '',
            size: '4xl'
        },

        WATER_BASED: {
            icon: 'fas fa-water',
            classAdj: '',
            size: '2xl'
        },
        ARCHIVE: {
            icon: 'ri-dropbox-fill',
            classAdj: '',
            size: '2xl'
        },
        HASHTAG: {
            icon: 'ri-hashtag',
            classAdj: '',
            size: '2xl'
        },
        SIGHTSEEING: {
            icon: 'ri-landscape-fill',
            classAdj: '',
            size: '2xl'
        },
        CULTURE: {
            icon: 'las la-users',
            classAdj: '',
            size: '4xl'
        },
        HISTORY: {
            icon: 'las la-landmark',
            classAdj: '',
            size: '4xl'
        },
        NATURE: {
            icon: 'las la-tree',
            classAdj: '',
            size: '4xl'
        },
        ENTERTAINMENT: {
            icon: 'las la-theater-masks',
            classAdj: '',
            size: '4xl'
        },
        PHYSICAL_INTENSE: {
            icon: 'las la-dumbbell',
            classAdj: '',
            size: '4xl'
        },
        PHYSICAL: {
            icon: 'fas fa-hiking',
            classAdj: '',
            size: '3xl'
        },
        RELAXED: {
            icon: 'las la-cocktail',
            classAdj: '',
            size: '4xl'
        },
        FOOD_RELATED: {
            icon: 'las la-utensils',
            classAdj: '',
            size: '4xl'
        }
    }
};

export default iconConsts;
